import React from "react";
import { Skeleton } from "@jem-open/jem-ui";

type SkeletonRowsProps = {
  columnCount: number;
};

const SkeletonRows: React.FC<SkeletonRowsProps> = ({ columnCount }) => (
  <>
    {Array.from({ length: 5 }).map((_row, rowIndex) => (
      // eslint-disable-next-line react/no-array-index-key
      <tr key={rowIndex}>
        {Array.from({ length: columnCount }).map((_col, colIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <td key={colIndex} style={{ border: "none", padding: "10px 10px" }}>
            <Skeleton className="h-4 w-full" />
          </td>
        ))}
      </tr>
    ))}
  </>
);

export default SkeletonRows;
